import { FAQComponentState, FAQComponentProps } from './faqcomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import { FAQCSSStyle } from './faqcss';
import * as React from 'react';
import { FaqDto, FaqDataListDto, FaqDataDto } from '../../../../core/dto/faq/faqdto';
import './faqcss.css';
import { Strings } from '../../../../utils/resources/strings';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';


export class FAQViewImpl extends CRBTUIViewImpl
{
     popupComponent:PopUpWrapperComponent ;
     answerList:string[];
     mobileAnswerList:string[];
    faqList: any;
    document =new Document();
    private loaderWrapperComponent:LoaderWrapperComponent;

     
    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);
    }

    bindHandlers()
    {
        this.showPopup = this.showPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
    }
    getChildComponent(props: FAQComponentProps, state: FAQComponentState, cssStyle: FAQCSSStyle): JSX.Element
    {   
        return (
           
                <>
                     <div id="faq-web">
                       {
                           this.getWebView(props, state,cssStyle)
                       }
                   </div>
                   <div id="faq-mobile">
                       {
                           this.getMobileView(props, state, cssStyle)
                       }

                 </div>
                   <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>
        <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }

    getWebView(props: FAQComponentProps, state: FAQComponentState, cssStyle: FAQCSSStyle)
    {
        return (
            <div style={{paddingLeft: "5%", paddingRight: "5%"}}>
            <label style={cssStyle.getFaqTextCSSStyle()}>
                    {props.context.getResources().getString(Strings.faq)}
            </label>
            <label style={cssStyle.getTitleTextCSSStyle()}>
            {
                props.context.getResources().getString(Strings.how_can_i_help_you)}
            </label>
            {
                state.listOfFaqs.map((faqDto: FaqDto, index: number) =>//
                {
                    return <details style={cssStyle.getWrapperCSSStyle()} key={index}>
                             <summary id="faq-question" style={cssStyle.getQuestionCSSStyle()}>{faqDto.getFaqQuestion()}</summary>
                             {faqDto.getFaqAnswerHeader() !== "" ?<label id="faq-answer" style={cssStyle.getAnswerCSSStyle()}>{faqDto.getFaqAnswerHeader()}</label>
                             :this.getEmptyAnswer()}
                           
                              {
                                  <ul id="faq-answer" style={cssStyle.getAnswerCSSStyle()}>
                                  {
                                  faqDto.getFaqDataList().map((faqDataListDto: FaqDataListDto, key: number)=>
                                  {
                                    return  <li id="faq-li" style={{width:"100%"}} key={key}>
                                          {
                                              faqDataListDto.getData().map((faqDataDto: FaqDataDto, position: number) =>
                                              {
                                                    return <span style={Object.assign(faqDataDto.getStyle(), {display:"inline"})} key={position}>{faqDataDto.getText()}</span>;
                                              })
                                          }
                                    </li>;
                                  })
                                }
                                  </ul>}
                             
                           </details>;
                })
            }
          
            </div>
        );
    }

    getMobileView(props: FAQComponentProps, state: FAQComponentState, cssStyle: FAQCSSStyle)
    {
        return (
            <>
            <label style={cssStyle.getMobileFaqTextCSSStyle()}>
                    {props.context.getResources().getString(Strings.faq)}
            </label>
            <label style={cssStyle.getMobileTitleTextCSSStyle()}>
            {
                props.context.getResources().getString(Strings.how_can_i_help_you)}
            </label>
            {
                state.listOfFaqs.map((faqDto: FaqDto, index: number) =>//
                {
                    return <details style={cssStyle.getWrapperCSSStyle()} key={index}>
                             <summary id="faq-question" style={cssStyle.getMobileQuestionCSSStyle()}>{faqDto.getFaqQuestion()}</summary>
                            
                            {
                                
                            }
                             {faqDto.getFaqAnswerHeader() !== "" ? <label id="faq-answer" style={cssStyle.getMobileAnswerCSSStyle()}>{faqDto.getFaqAnswerHeader()}</label>
                             :  this.getEmptyAnswer()}
                            

                            {       
                              <ul id="faq-answer" style={cssStyle.getMobileAnswerCSSStyle()}>
                               {
                                  faqDto.getFaqDataList().map((faqDataListDto: FaqDataListDto, key: number)=>
                                  {
                                    return  <li id="faq-li" style={{width:"100%"}} key={key}>
                                          {
                                              faqDataListDto.getData().map((faqDataDto: FaqDataDto, position: number) =>
                                              {
                                                    return <span style={Object.assign(faqDataDto.getStyle(), {display:"inline"})} key={position}>{faqDataDto.getText()}</span>;
                                              })
                                          }
                                    </li>;
                                  })
                                }
                                  </ul>}

                             
                           </details>;
                })
            }
            </>
        );
    }

    getEmptyAnswer():JSX.Element
    {
        return <span/>;
    }
    showLoader()
    {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
    }
    
    closePopup()
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }
    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home),
                this.getUIProps().context.getResources().getString(Strings.faq)];
    }

    getBannerImg()
    {
        return "categories.jpg";
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/faq/faqview.tsx